import { ISelect } from '@/interface/utils.model';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';

@Component({
  selector: 'app-typeahead',
  templateUrl: './typeahead.component.html',
  styleUrls: ['./typeahead.component.scss']
})
export class TypeaheadComponent implements OnChanges {
  @Input() control: AbstractControl = new FormControl();
  @Input() label: string = "";
  @Input() idForm: string;
  @Input() data: Array<any> = [];
  @Input() optField: string;
  @Input() optGroup: string;
  @Input() optLimit: number = 7;
  @Input() placeholder: string = "";
  @Input() size: string = "";
  @Input() autocomplete: boolean = true;
  @Output() onSelectItem = new EventEmitter();
  obj: Array<any>


  ngOnChanges(changes: SimpleChanges): void {    
    if (!this.data) return
    this.obj = this.data.map(val => <ISelect>{
      descripcion: val[this.optField],
      ...val
    });   
  }

  onSelect(event: TypeaheadMatch): void {
    this.onSelectItem.emit(event.item);
  }

  onBlur(event, input): void {
    if(input.value == '') this.onSelectItem.emit(null);
  }
}
